import { createMessagingClient } from 'src/shared/messaging-kit/createMessagingClient';
import { authenticationService } from 'src/config/rootService';
import { capture } from 'src/shared/helpers/sentryCapture';

export const messagingClient = createMessagingClient({
    httpURI: process.env.REACT_APP_TALKTALK_GRAPHQL_URL as string,
    webSocketURI: process.env.REACT_APP_TALKTALK_GRAPHQL_WS_URL as string,
    async getAuthenticationData() {
        try {
            const authData = await authenticationService.refresh();

            if (!authData) {
                return null;
            }

            return { authToken: authData.access_token, tokenType: authData.token_type };
        } catch {
            // authenticationService.refresh() throws, handle it gracefully
            return null;
        }
    },
    onError(error: unknown) {
        capture(error);
    },
});
